import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="border-t border-line py-10 px-6 lg:px-10">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="font-mono text-xs text-dim tracking-[0.2em]">
          {t.footer.left}
        </p>
        <div className="flex items-center gap-8">
          <p className="font-mono text-xs text-dim tracking-[0.2em]">{t.footer.right}</p>
          <Link to="/inbox" data-testid="footer-inbox-link" className="font-mono text-xs text-line hover:text-volt tracking-[0.2em]">
            {t.footer.inbox}
          </Link>
        </div>
      </div>
    </footer>
  );
};
